import { RouteComponentProps } from 'react-router-dom';

import * as api from '../api';
import * as store from '../reducers/store';
import * as FormUtils from './form';

export function determineNextPage(args: {
  page: number;
  forms: store.Forms;
  selectedFormId?: string;
  patient: api.Patient.Patient | null;
  practicePreference: api.Previsit.PracticePreference;
}): number {
  const { page, forms, selectedFormId, patient, practicePreference } = args;
  const isLastPageOfForm = selectedFormId
    ? Math.max(...forms[selectedFormId].fields.map((f) => f.page)) === page
    : false;
  if (isLastPageOfForm) {
    const isFormSetComplete = FormUtils.isFormSetComplete(
      Object.values(forms),
      patient,
      practicePreference,
    );
    return isFormSetComplete ? page + 1 : 0;
  }
  return page + 1;
}

export function setPagePart(
  history: RouteComponentProps['history'],
  location: RouteComponentProps['location'],
  part: number,
) {
  history.push({
    pathname: location.pathname,
    search: `?page=${getIntegerParamFromLocationSearch(
      location.search,
      'page',
    )}&part=${part}`,
  });
}

export function getParamFromLocationSearch(
  search: string,
  param: string,
): string | undefined {
  const [, params] = search.split('?');
  if (!params) return undefined;
  const match = params.split('&').find((c) => c.startsWith(`${param}=`));
  if (!match) return undefined;
  const [, value] = match.split(`${param}=`);
  return value;
}

export function getIntegerParamFromLocationSearch(
  search: string,
  param: string,
): number | null {
  const value = getParamFromLocationSearch(search, param);
  return (value && parseInt(value, 10)) || null;
}

export function getPageFormFields(
  page: number,
  fields: store.FormFieldWithConfig[],
): store.FormFieldWithConfig[] {
  return fields.filter((ff) => ff.page === page);
}

export function getNextIndex(
  current: number | undefined,
  step: number,
  length: number,
): number | undefined {
  if (!length) return;
  const startingIndex = step > 0 ? 0 : length - 1;
  const currentIndex = current === undefined ? startingIndex : current + step;
  return ((currentIndex % length) + length) % length;
}
